import React from "react";
import "../shared/index.css";

export function Step2() {
  return (
    <div className="onboarding-steps">
      <h1 className="onboarding-step--title">Step 2</h1>
      <p className="onboarding-step--description">
        We only accept items that has been washed.
        Washed items that have been stored can develop
        mold and unpleasant smell. Please wash the items right
        before sending them to us.
      </p>
      <div className="onboarding-facts">
        <h4>Facts</h4>
        <p>
          80% of all returned items by customers are smelly and unhygeinic.
        </p>
      </div>
    </div>
  );
}
